import { IStringToString } from '../interfaces/core';
import { gameStore } from '../stores';

class TranslationApiService {

  getTranslations = async (): Promise<IStringToString> => {
    try {
      const response = await fetch(`${process.env.REACT_APP_TRANSLATION_URL}/api/v1/Translations?applicationId=${gameStore.applicationId}&isoCode=${gameStore.language}`);
      if (response.ok) {
        const responseData = await response.json();
        return responseData.data;
      }

      return {};
    } catch (e) {
      return {};
    }
  }

}

export const translationApiService = new TranslationApiService();
